import Vue from 'vue';

// @ts-ignore
export const setVersion = (state, version) => {
  state.version = version.version;
  state.date = version.date;
};
